import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

// Async thunk to fetch contact numbers
export const fetchContactNumbers = createAsyncThunk(
    'contactNumbers/fetchContactNumbers',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get('/contacts/contact-numbers');
            return response.data.contactNumbers;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// Async thunk to set contact numbers
export const setContactNumbers = createAsyncThunk(
    'contactNumbers/setContactNumbers',
    async ({ packageType, phone, whatsapp, phone2, isActive }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/contacts/contact-numbers', {
                packageType,
                phone,
                whatsapp,
                phone2: phone2 || null,
                isActive,
            });
            return response.data.contactNumber;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

const contactNumbersSlice = createSlice({
    name: 'contactNumbers',
    initialState: {
        contactNumbers: {},
        loading: false,
        error: null,
        success: null,
    },
    reducers: {
        clearMessages: (state) => {
            state.error = null;
            state.success = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch contact numbers
            .addCase(fetchContactNumbers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchContactNumbers.fulfilled, (state, action) => {
                state.loading = false;
                state.contactNumbers = action.payload;
            })
            .addCase(fetchContactNumbers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Set contact numbers
            .addCase(setContactNumbers.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = null;
            })
            .addCase(setContactNumbers.fulfilled, (state, action) => {
                state.loading = false;
                state.contactNumbers[action.payload.packageType] = {
                    phone: action.payload.phone,
                    whatsapp: action.payload.whatsapp,
                    phone2: action.payload.phone2,
                    isActive: action.payload.isActive,
                };
                state.success = 'Contact numbers set successfully!';
            })
            .addCase(setContactNumbers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearMessages } = contactNumbersSlice.actions;
export default contactNumbersSlice.reducer;